import React from 'react';
import ProductVariantList from '../components/ProductVariantList';

const ProductVariantsPage = () => {
    return <ProductVariantList />;
};

export default ProductVariantsPage;